<template>
  <div>
    <barra-navegacao :visiblebutton="true"/>
    <div style="padding: 8px;">
      <b-tabs content-class="mt-3">
        <b-tab title="Em Aberto" v-if="deveExibirSecaoChamadosSetor" active>
          <template #title>
            <strong>Em Aberto</strong>&emsp;<b-badge variant="danger" v-if="chamados.setor.length > 0">
            {{ chamados.setor.length }}
          </b-badge>
          </template>
          <div v-if="deveExibirSecaoChamadosSetor">
            <SecaoVazia v-if="!temChamados(chamados.setor)"/>
            <div v-else>
              <ChamadoCard
                  v-for="(chamado, index) in chamados.setor"
                  :key="index"
                  :chamado="chamado"
                  @atender="atenderChamado"
              />
            </div>
          </div>
        </b-tab>
        <b-tab title="Em Atendimento" v-if="deveExibirSecaoEmAtendimento">
          <template #title>
            <strong>Em Atendimento</strong>&emsp;<b-badge variant="danger">{{ chamados.emAtendimento.length }}</b-badge>
          </template>
          <SecaoVazia v-if="!temChamados(chamados.emAtendimento)"/>
          <div v-else>
            <ChamadoCard
                v-for="(chamado, index) in chamados.emAtendimento"
                :key="index"
                :chamado="chamado"
                tipo="em-atendimento"
                @finalizar="finalizarChamado"
            />
          </div>
        </b-tab>
        <b-tab title="Meus Chamados" v-if="deveExibirSecaoMeusChamados">
          <template #title>
            <strong>Meus Chamados</strong>
          </template>
          <SecaoVazia v-if="!temChamados(chamados.meus)"/>
          <div v-else>
            <ChamadoCard
                v-for="(chamado, index) in chamados.meus"
                :key="index"
                :chamado="chamado"
                tipo="visualizacao"
            />
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <!-- Modal para texto de assentamento -->
    <b-modal
        v-model="modalAssentamento.exibir"
        :title="`Chamado #${modalAssentamento.chamado && modalAssentamento.chamado.id }`"
        @ok="confirmarFinalizacaoChamado"
        @cancel="cancelarFinalizacao"
        ok-title="Finalizar"
        cancel-title="Cancelar"
        size="lg"
        centered
    >
      <div class="mb-4"
           v-html="formatarDescricao(modalAssentamento.chamado ? modalAssentamento.chamado.descricao : '')"></div>
      <b-form-group
          class="font-weight-bolder"
          label="Assentamento:"
          label-for="texto-assentamento"
      >
        <b-form-textarea
            id="texto-assentamento"
            v-model="modalAssentamento.textoAssentamento"
            placeholder="Digite aqui a resolução do chamado..."
            rows="6"
            max-rows="10"
            maxlength="300"
            required
        ></b-form-textarea>
        <small class="text-muted mt-1 d-flex justify-content-between">
          <span style="color: red;">* Campo obrigatório</span>
          <span>{{ modalAssentamento.textoAssentamento.length }}/300 caracteres</span>
        </small>
      </b-form-group>
    </b-modal>

  </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';
import ChamadoCard from '../components/ChamadoCard.vue';
import SecaoVazia from '../components/SecaoVazia.vue';
import {PerfilService} from '@/services/PerfilService';

const ENDPOINTS = {
  CHAMADOS_USUARIO: '/ocorrencia/chamado-aberto-usuario',
  CHAMADOS_SETOR: '/ocorrencia/chamados-abertos-setor',
  CHAMADOS_ATENDIMENTO: '/ocorrencia/chamado-atendimento-usuario'
};

const FILTRO_DESCRICAO = 'Problema:';
const STATUS_FINALIZADO = 18;

const TIPOS_ALERTA = {
  SUCESSO: 'success',
  ERRO: 'error'
};

const MENSAGENS = {
  CHAMADO_ATENDIDO: 'Chamado atendido com sucesso!',
  CHAMADO_FINALIZADO: 'Chamado finalizado com sucesso!',
  ERRO_INTERNO: 'Ocorreu um erro interno, tente novamente mais tarde.',
  SUCESSO: 'Sucesso',
  ERRO: 'Erro'
};

export default {
  components: {
    BarraNavegacao,
    ChamadoCard,
    SecaoVazia
  },

  data() {
    return {
      perfil: null,
      usuario: '',
      ws: null,
      chamados: {
        meus: [],
        setor: [],
        emAtendimento: []
      },
      modalAssentamento: {
        exibir: false,
        chamado: null,
        textoAssentamento: ''
      }
    }
  },

  computed: {
    deveExibirSecaoMeusChamados() {
      return true;
    },
    deveExibirSecaoChamadosSetor() {
      return this.perfil && this.perfil.ehAdministradorOuOperador || false;
    },
    deveExibirSecaoEmAtendimento() {
      return this.perfil && this.perfil.ehAdministradorOuOperador || false;
    }
  },

  created() {
    this.inicializarComponente();
  },

  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  },

  methods: {
    inicializarComponente() {
      this.perfil = new PerfilService();
      this.usuario = localStorage.getItem('usuario') || '';
      this.carregarTodosChamados();
    },

    connectWebsocket() {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        return;
      }

      const token = localStorage.getItem('wss');

      if (!token) {
        console.error('Token não encontrado para WebSocket');
        return;
      }

      try {
        this.ws = new WebSocket(`wss://helpdesk.uninorteac.edu.br/api/ws/?token=${token}`);

        this.ws.onopen = () => {
          console.log('WebSocket conectado com sucesso!');
        };

        this.ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            if (data.type === 'CHAMADO') {
              this.carregarChamadosSetor();
            }
          } catch (error) {
            console.error('Erro ao processar mensagem WebSocket:', error);
          }
        };

        this.ws.onerror = (error) => {
          console.error('Erro ao conectar ao WebSocket:', error);
        };

        this.ws.onclose = (event) => {
          console.log('WebSocket desconectado. Código:', event.code, 'Motivo:', event.reason);
        };

      } catch (error) {
        console.error('Erro ao criar WebSocket:', error);
      }
    },

    carregarTodosChamados() {
      this.carregarChamadosUsuario();

      if (this.perfil.ehAdministradorOuOperador) {
        this.carregarChamadosSetor();
        this.carregarChamadosEmAtendimento();
        this.connectWebsocket();
      }
    },

    carregarChamadosUsuario() {
      this.executarRequisicaoChamados(ENDPOINTS.CHAMADOS_USUARIO, 'meus');
    },

    carregarChamadosSetor() {
      this.executarRequisicaoChamados(ENDPOINTS.CHAMADOS_SETOR, 'setor');
    },

    carregarChamadosEmAtendimento() {
      this.executarRequisicaoChamados(ENDPOINTS.CHAMADOS_ATENDIMENTO, 'emAtendimento');
    },

    executarRequisicaoChamados(endpoint, tipoChamados) {
      this.$http
          .get(endpoint)
          .then((response) => {
            this.chamados[tipoChamados] = this.filtrarChamadosValidos(response.data, tipoChamados);
          })
          .catch(this.tratarErroRequisicao);
    },

    filtrarChamadosValidos(dadosChamados, tipoChamados) {
      const chamadosValidos = dadosChamados && dadosChamados.filter ? dadosChamados.filter(chamado =>
          chamado.descricao.includes(FILTRO_DESCRICAO)
      ) : [];

      if (tipoChamados === 'setor') {
        return chamadosValidos.filter(chamado => chamado.cliente.login !== this.usuario);
      }

      if (tipoChamados === 'emAtendimento') {
        return chamadosValidos.filter(chamado => parseInt(chamado.status.id) !== STATUS_FINALIZADO);
      }

      return chamadosValidos;
    },

    temChamados(listaChamados) {
      return Array.isArray(listaChamados) && listaChamados.length > 0;
    },

    atenderChamado(chamado) {
      const parametros = this.criarParametrosRequisicao(chamado);
      const endpoint = `/ocorrencia/${chamado.id}/atender${parametros}`;

      this.$http.post(endpoint)
          .then(() => this.processarSucessoChamado(MENSAGENS.CHAMADO_ATENDIDO))
          .catch(() => this.processarErroChamado());
    },

    finalizarChamado(chamado) {
      this.modalAssentamento.chamado = chamado;
      this.modalAssentamento.textoAssentamento = '';
      this.modalAssentamento.exibir = true;
    },

    confirmarFinalizacaoChamado(evento) {
      evento.preventDefault();

      const textoAssentamento = this.modalAssentamento.textoAssentamento ? this.modalAssentamento.textoAssentamento.trim() : '';

      if (!textoAssentamento) {
        this.exibirAlerta(
            'O texto de assentamento é obrigatório para finalizar o chamado.',
            MENSAGENS.ERRO,
            TIPOS_ALERTA.ERRO
        );
        return;
      }

      if (textoAssentamento.length < 5) {
        this.exibirAlerta(
            'O texto de assentamento deve ter pelo menos 5 caracteres.',
            MENSAGENS.ERRO,
            TIPOS_ALERTA.ERRO
        );
        return;
      }

      // Proceder com a finalização
      this.executarFinalizacaoChamado(this.modalAssentamento.chamado, textoAssentamento);
    },

    executarFinalizacaoChamado(chamado, textoAssentamento) {
      const payload = this.criarPayloadRequisicaoFinalizar(chamado, textoAssentamento);
      const endpoint = `/ocorrencia/${chamado.id}/finalizar`;

      this.$http.post(endpoint, payload)
          .then(() => {
            this.modalAssentamento.exibir = false;
            this.processarSucessoChamado(MENSAGENS.CHAMADO_FINALIZADO);
          })
          .catch(() => {
            this.modalAssentamento.exibir = false;
            this.processarErroChamado();
          });
    },

    cancelarFinalizacao() {
      this.modalAssentamento.exibir = false;
      this.modalAssentamento.chamado = null;
      this.modalAssentamento.textoAssentamento = '';
    },

    buscarEmpresaSetor(chamado) {
      return chamado.empresa_setores.find(x => x.setor.id === chamado.rotina.problema.id_setor);
    },

    criarParametrosRequisicao(chamado) {
      const empresa = this.buscarEmpresaSetor(chamado);
      return `?setor=${empresa.setor.nome}&id_setor=${empresa.id}&solicitante=${chamado.cliente.login}`;
    },

    criarPayloadRequisicaoFinalizar(chamado, textoAssentamento) {
      const empresa = this.buscarEmpresaSetor(chamado);
      return {
        setor: empresa.setor.nome,
        idSetor: empresa.id,
        solicitante: chamado.cliente.login,
        assentamento: textoAssentamento
      }
    },

    processarSucessoChamado(mensagem) {
      this.exibirAlerta(mensagem, MENSAGENS.SUCESSO, TIPOS_ALERTA.SUCESSO);
      this.carregarTodosChamados();
    },

    processarErroChamado() {
      this.exibirAlerta(MENSAGENS.ERRO_INTERNO, MENSAGENS.ERRO, TIPOS_ALERTA.ERRO);
    },

    tratarErroRequisicao(erro) {
      console.error('Erro ao carregar chamados:', erro);
    },

    formatarDescricao(descricao) {
      return descricao ? descricao.replace('<br>', '') : '';
    },

    exibirAlerta(mensagem, titulo, tipo) {
      this.$fire({
        title: titulo,
        text: mensagem,
        type: tipo
      }).then((r) => {
        r.value;
      });
    }
  }
};
</script>

<style scoped></style>
